import { render } from "./GameBoard.vue?vue&type=template&id=92bf4666"
import script from "./GameBoard.vue?vue&type=script&lang=js"
export * from "./GameBoard.vue?vue&type=script&lang=js"
script.render = render

export default script